import { DiscountKind } from "../../common/discount-kind";

class SaleDocumentItemDTO {
	public cnCode: string | null;
	public discountKind: DiscountKind;
	public discountValue: number;
	public jpkVatGroups: string[];
	public no: number;
	public note: string | null;
	public pkwiu: string | null;
    public barCode: string;
    public symbol: string;
	public productId: number | null;
	public productName: string | null;
	public quantity: number;
	public unitId: number;
	public vatRateId: number;
	public jpkVatProcedure: string | null;
	public relatedInventoryItemsIds: number[];
	public includesInventoryControl: boolean;
}

export class SaleDocumentUpdateItemDTO extends SaleDocumentItemDTO {
	public unitGrossPrice: number;
	public unitNetPrice: number;
	public unitCost: number;
}

export class SaleDocumentGetItemDTO extends SaleDocumentItemDTO {
	public id: number;
	public advance?: number;
	public cost: number;
	public grossValueAfterDiscount: number;
	public grossValue: number;
	public netValueAfterDiscount: number;
	public netValue: number;
	public unitCost: number;
	public unitGrossPriceAfterDiscount: number;
	public unitGrossPrice: number;
	public unitNetPriceAfterDiscount: number;
	public unitNetPrice: number;
	public vatValueAfterDiscount: number;
	public vatValue: number;
}
